<div class="row p-1">
  <div class="col-12 pageTitle">
    <h2>&nbsp;&nbsp;&nbsp;Report List</h2>
  </div>
</div>

<div class="card col-12 pt-0 pb-0 mb-2">
  <div class="p-fluid formgrid grid" style="justify-content: space-between">
    <div class="field col-12 md:col-4 xl:col-4 pt-3 mb-3">
      <span class="ui-float-label">
        <p-dropdown
          *ngIf="reportCategoryList"
          dataKey="reportCategoryId"
          [options]="reportCategoryList"
          optionLabel="reportCategoryName"
          placeholder="Report Category"
          class="ui-fluid"
          [(ngModel)]="selectedReportCategory"
          (onChange)="searchonId(selectedReportCategory)"
        ></p-dropdown>
      </span>
    </div>

    <div class="field col-2 md:col-4 lg:col-4 xl:col-3 alignRight pt-3 mb-2">
      <button
        pButton
        type="button"
        pTooltip=""
        label="Create Report"
        pTooltipPosition="true"
        icon="pi pi-book"
        [disabled]="selectedReportCategory == null"
        class="ui-button-plain buttonWidth-14 GreyButton"
        (click)="onAddReports()"
      ></button>
    </div>
  </div>
</div>

<!--<p-table *ngIf="report" [columns]="cols" [value]="report.data" selectionMode="single" dataKey="reportID" [resetPageOnSort]="false" [lazy]="false"
         [(selection)]="selectedReport" [paginator]="showRecords" [rows]="10">-->

<!--<p-table *ngIf="report"
         [columns]="cols"
         [alwaysShowPaginator]="false"
         [rows]="rows"
         [paginator]="showRecords"
         [value]="report?.data"
         selectionMode="single"
         [sortOrder]="1"
         sortField="reportID"
         dataKey="reportID"
         [(selection)]="selectedReport"
         [autoLayout]="true"
         (sortFunction)="customSort($event, 1)"
         
         [customSort]="true">-->

<p-table 
         [responsive]="true"
         [columns]="cols"
         [value]="reports|async"
         selectionMode="single"
         dataKey="reportID"
         [resetPageOnSort]="false"
         [lazy]="false"
         [rows]="rows"
         [paginator]="showRecords"
>


    <ng-template pTemplate="header" let-columns>
        <tr *ngIf="showRecords == true">
            <th *ngFor="let col of columns"
                [pSortableColumn]="col.field"
                class="col-2">
                {{ col.header }}
                <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
            <th class="col-3 md:col-2 lg:col-2 xl:col-2" style="text-align: center">
                Actions
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
            <td *ngFor="let col of columns">
                <ng-container *ngIf="col.field != 'patientFlag'; else ptflag">
                    {{ rowData[col.field] }}
                </ng-container>
                <ng-template #ptflag>
                    <ng-container *ngIf="rowData['patientFlag'] && col.field == 'patientFlag'; else ptflagNo">Yes</ng-container>
                </ng-template>
                <ng-template #ptflagNo>No</ng-template>
            </td>
            <td style="text-align: center !important">
                <button pButton type="button" icon="pi pi-link" pTooltip="Add Params" class="p-button-link" (click)="onParamReport(rowData['reportID'], rowData['reportDisplayName'])"></button>
                <button pButton type="button" icon="pi pi-pencil" pTooltip="Edit" class="p-button-link ml-3" (click)="onEditReport(rowData['reportID'])"></button>
                <button pButton type="button" icon="pi pi-trash" pTooltip="Delete" class="p-button-link ml-3" (click)="onDeleteReport($event, rowData['reportID'])"></button>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <div class="w-12 bg-white">
            <div class="" style="text-align: center">
                <img _ngcontent-ng-c683320295="" class="profile-image" style="border-radius: 50%; width: 10rem; padding-top: 1rem" src="assets/imagesNew/table_error.png" />
            </div>
            <hr style="margin-bottom: 0.5rem" />
            <div class="" style="text-align: center; font-size: larger; color: #1d428f">
                <i>No records found</i>
            </div>
        </div>
    </ng-template>


    <ng-template pTemplate="paginatorleft" let-state>

        <span *ngIf="state.totalRecords > pageSize">
            Showing {{ state.page * state.rows + 1 }} to
            {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
        </span>
    </ng-template>
</p-table>
